import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createComponent } from "../../services/component";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useCreateComponent = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createComponent,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                toast.success("Component created successfully");
            }
        },

        onError: (error:any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
};

export default useCreateComponent;